import React, { useCallback, useContext } from 'react'

// DEPENDENCIES
import snakeCase from 'lodash/snakeCase';

// GLOBAL VARIABLES
//import { INVENTORY_STATUS } from 'codes.js';
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { doCallback, documentFetch, fileDownload, makePath } from 'functions.js';

// CONTEXT
import { DropdownContext } from 'core/tools/dropdown/helpers/dropdownContext';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Button from 'core/tools/Button';
import Dropdown from 'core/tools/dropdown/Dropdown';
import Sprite from 'core/tools/Sprite';

// STYLES
import styles from './printButton.module.scss';

// COMPONENTS
const PrintOption = ({
  label,
  endpoint,
  params
}) => {

  // CONTEXT
  const { setShow } = useContext(DropdownContext) || {};

  // HOOKS
  const { recordID } = useRecordContext() || {};

  // CALLBACKS
  const handleClick = useCallback(
    () => {
      doCallback(setShow, false)
      documentFetch({
        endpoint: makePath(endpoint, recordID),
        accept: 'application/pdf',
        params,
        loadingMessage: 'Downloading your report',
        successMessage: 'The report has been download successfully!',
        onSuccess: ({ url }) => fileDownload(url, `${snakeCase(label)}_${recordID}`, 'pdf')
      })
    },
    [label, endpoint, recordID, params]
  )

  // RENDER
  return (
    <Button
      variant="custom"
      className={styles.optionButton}
      label={label}
      onClick={handleClick}
      justify="start"
    />
  )  
}

// MAIN COMPONENT
const PrintButton = () => {

  // HOOKS
  /*
  const {
    record: {
      source_sales_id,
      inventory_status_code,
    } = {}
  } = useRecordContext() || {};
   */

  // RENDER
  return <Dropdown
    toggle={{
      children: <>
        <Sprite use="print" className={styles.sprite} />
        <span>Print</span>
      </>,
      outline: true
    }}
    menu={{
      className: styles.menu
    }}
    size='sm'
    align="start"
    useArrow={false}
  >
    <PrintOption
      label="Vehicle Info"
      endpoint={ENDPOINTS.print.inventory.vehicleInfo}
    />
    <PrintOption
      label="Buyer's Guide"
      endpoint={ENDPOINTS.print.inventory.buyersGuide}
    />
    <PrintOption
      label="Permission to Drive"
      endpoint={ENDPOINTS.print.inventory.permissionToDrive}
    />
    {/*
    <PrintOption
      label="Request/Pending Detail Form"
      endpoint={ENDPOINTS.print.inventory.requestDetail}
    />
    <PrintOption
      label="Cleanup Form"
      endpoint={ENDPOINTS.print.inventory.requestCleanup}
      params={inventory_status_code === INVENTORY_STATUS.sold.code && {source_sales_id})}
    />
    */}
  </Dropdown>
};

// EXPORT
export default PrintButton;
